import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { VacationRoutingModule } from './vacation-routing.module';
import { ButtonModule } from 'primeng/button';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { VacationComponent } from './vacation.component';
import { VacationRegisterModalComponent } from './components/vacation-register-modal/vacation-register-modal.component';
import { ModalInfoComponent } from './components/modal-info/modal-info.component';
import { VacationEditModalComponent } from './components/vacation-edit-modal/vacation-edit-modal.component';
import { VacationDetailModalComponent } from './components/vacation-detail-modal/vacation-detail-modal.component';
import { DividerModule } from 'primeng/divider';

@NgModule({
  declarations: [VacationComponent,
    VacationRegisterModalComponent,
    VacationEditModalComponent,
    VacationDetailModalComponent,
    ModalInfoComponent
  ],
  imports: [
    CommonModule,
    // BrowserModule,
    VacationRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    MatPseudoCheckboxModule,
    AutoCompleteModule,
    ButtonModule,
    InputSwitchModule,
    CheckboxModule,
    DividerModule
  ],
  providers: [DialogService],
})
export class VacationModule {}
